import React from 'react';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import { Routes, Route } from 'react-router-dom';
import Services from './components/pages/Services';
import Service1 from './components/pages/Service1';
import SignUp from './components/pages/SignUp';
import Destination from './components/pages/Destination';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import Contact1 from './components/pages/Contact1';
import About from './components/pages/About';
import Card1 from './components/pages/Card1';
import ProductDetail from './components/pages/Productdet';
import Footer from './components/Footer';
import Stepp from './components/Stepp';
import Destination1 from './components/details/Destination1';
import Destination2 from './components/details/Destination2';
import Destination3 from './components/details/Destination3';
import Destination4 from './components/details/Destination4';
import Destination5 from './components/details/Destination5';
import Destination6 from './components/details/Destination6';
import Destination7 from './components/details/Destination7';
import Destination8 from './components/details/Destination8';
import Swipernew from './components/details/Swipernew';
function App() {
  return (
    <div className='App'>
      <Navbar />
      <ScrollToTop> 
     
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='/services' exact element={<Services />} />
          <Route path='/sign-up' exact element={<SignUp />} />
          <Route path='/contact' exact element={<Contact1 />} />
          <Route path='/about' exact element={<About/>} />
          <Route path='/services/activity' element={<Destination />} />
          <Route path='/1' element={<Card1/>} />
          <Route path='/detail' element={<ProductDetail/>} />
          <Route path='/detail1' element={<Destination1/>} />
          <Route path='/detail2' element={<Destination2/>} />
          <Route path='/detail3' element={<Destination3/>} />
          <Route path='/detail4' element={<Destination4/>} />
          <Route path='/detail5' element={<Destination5/>} />
          <Route path='/detail6' element={<Destination6/>} />
          <Route path='/detail7' element={<Destination7/>} />
          <Route path='/detail8' element={<Destination8/>} />
          <Route path='/step' element={<Stepp/>} />
          <Route path='/service1' element={<Service1/>} />
          <Route path='/s2' element={<Swipernew/>} />
        </Routes>
   
      </ScrollToTop>
      <Footer/>
    </div>
  );
}

export default App;
